module.exports = __webpack_public_path__ + "img/japan-respiratory-diseases-male.711cf9ca.png";